import type { Theme } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

const lightModeTheme: Theme = createTheme({
    palette: {
        primary: {
            main: '#007A8C',
        },
        secondary: {
            main: '#9C27B0',
        },
        error: {
            main: '#D1232C',
        },
        info: {
            main: '#0288D1',
        },
        background: {
            default: '#F5F7F9',
            paper: '#EBECEF',
        },
        text: {
            primary: '#000000',
        },
    },
});

export default lightModeTheme;